<template>
  <div class="price-display">
    <p class="total-price">Total : {{ formattedTotalPrice }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useConfigStore } from '../../stores/configStore'

const configStore = useConfigStore()
const formattedTotalPrice = computed(() => configStore.formattedTotalPrice)
</script>

<style scoped>
.price-display {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.total-price {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}
</style>
